export default __webpack_public_path__ + "static/16_37-cf1315a94f6d399305b762c3fde92a49.png";